"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Editor;
const React = __importStar(require("react"));
const ace_builds_1 = require("ace-builds");
const js_beautify_1 = __importDefault(require("js-beautify"));
const react_ace_1 = __importDefault(require("react-ace"));
//import "ace-builds/src-noconflict/ext-language_tools"
require("ace-builds/src-noconflict/mode-javascript");
require("ace-builds/webpack-resolver"); // Ace worker
require("./Editor.scss");
const beautfy_options = {
    indent_size: "4",
    indent_char: " ",
    max_preserve_newlines: "5",
    preserve_newlines: true,
    keep_array_indentation: false,
    break_chained_methods: true,
    indent_scripts: "normal",
    brace_style: "collapse",
    space_before_conditional: true,
    unescape_strings: false,
    jslint_happy: false,
    end_with_newline: false,
    wrap_line_length: "80",
    indent_inner_html: false,
    comma_first: false,
    e4x: false,
    indent_empty_lines: false,
};
function Editor(props) {
    const editorRef = React.useRef(null);
    React.useEffect(() => {
        const cursor = editorRef.current.editor.getCursorPosition();
        editorRef.current.editor.setValue(props.startValue);
        editorRef.current.editor.clearSelection();
        editorRef.current.editor.moveCursorTo(cursor.row, cursor.column);
    }, [props.startValue]);
    React.useEffect(() => {
        if (!editorRef.current)
            return;
        const element = document.getElementById("root");
        function toggle(e) {
            if (e.key === " " && e.shiftKey && e.metaKey) {
                element.classList.toggle("editor--alt");
                editorRef.current.editor.clearSelection();
                e.preventDefault();
            }
        }
        document.body.addEventListener("keydown", toggle);
        document.body.style.fontFamily = "Fixedsys Excelsior";
        return () => {
            document.body.removeEventListener("keydown", toggle);
        };
    }, [editorRef]);
    React.useEffect(() => {
        if (!editorRef.current)
            return;
        if (props.hide) {
            editorRef.current.editor.container.classList.add("editor__code--hidden");
        }
        else {
            editorRef.current.editor.container.classList.remove("editor__code--hidden");
        }
    }, [props.hide]);
    const commands = [
        {
            name: "toggleCode",
            bindKey: { win: "Ctrl-H", mac: "Ctrl-Shift-H" },
            exec: e => {
                editorRef.current.editor.container.classList.toggle("editor__code--hidden");
                if (props.onChangeVisibility)
                    props.onChangeVisibility(!editorRef.current.editor.container.classList.contains("editor__code--hidden"));
            },
        },
        {
            name: "eval:line",
            bindKey: { win: "Alt-Enter", mac: "Ctrl-Enter" },
            exec: () => {
                var _a;
                const editor = (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor;
                if (!editor || !props.onRun)
                    return;
                const cursor = editor.getCursorPosition();
                const fullCode = editor.getValue() || "";
                const line = editor.session.getLine(cursor.row);
                addMarker(cursor.row + 1, 0, cursor.row + 1, line.length);
                props.onRun(line, fullCode);
            },
        },
        {
            name: "eval:block",
            bindKey: { win: "Ctrl-Enter", mac: "Option-Enter" },
            exec: () => {
                var _a;
                const editor = (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor;
                if (!editor || !props.onRun)
                    return;
                const cursor = editor.getCursorPosition();
                const fullCode = editor.getValue() || "";
                const block = getCurrentBlock();
                addMarker(block.start, 0, block.end, block.text.length);
                props.onRun(block.text, fullCode);
            },
        },
        {
            name: "eval:all",
            bindKey: { win: "Ctrl-Shift-Enter", mac: "Ctrl-Shift-Enter" },
            exec: () => {
                var _a;
                const editor = (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor;
                if (!editor || !props.onRun)
                    return;
                const fullCode = editor.getValue() || "";
                addMarker(0, 0, editor.session.getLength() + 1, 0);
                props.onRun(fullCode, fullCode);
            },
        },
        {
            name: "format",
            bindKey: { win: "Ctrl-Shift-F", mac: "Command-Shift-F" },
            exec: () => {
                var _a;
                const editor = (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor;
                if (!editor || !props.onRun)
                    return;
                const beautified = (0, js_beautify_1.default)(editor.getValue(), beautfy_options);
                props.onRun(beautified, beautified);
            },
        },
    ];
    function getCurrentBlock() {
        var _a;
        const editor = (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor;
        const cursor = editor.getCursorPosition();
        var startline = cursor.row;
        var endline = cursor.row;
        while (startline > 0 && editor.session.getLine(startline) !== "")
            startline--;
        while (endline <= editor.session.getLength() && editor.session.getLine(endline) !== "")
            endline++;
        return {
            start: startline > 0 ? (startline + 2 > endline ? endline : startline + 2) : 0,
            end: endline,
            text: editor.session.getTextRange(new ace_builds_1.Range(startline, 0, endline, 0)),
        };
    }
    function addMarker(startLine, startPos, stopLine, stopPos) {
        const markerId = editorRef.current.editor.session.addMarker(new ace_builds_1.Range(startLine - 1, startPos, stopLine - 1, stopPos), "ace-marker", "text", true);
        setTimeout(() => {
            editorRef.current.editor.session.removeMarker(markerId);
        }, 300);
    }
    React.useEffect(() => {
        var _a;
        const editor = (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.editor;
        if (!editor)
            return;
        function handleKeyDown(e) {
            if ((e.metaKey && e.key === "Meta") || (e.ctrlKey && e.key === "Control")) {
                editor.container.style.pointerEvents = "none";
            }
        }
        function handleKeyUp(e) {
            if (e.key === "Meta" || e.key === "Control") {
                editor.container.style.pointerEvents = "";
            }
        }
        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("keyup", handleKeyUp);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("keyup", handleKeyUp);
        };
    }, [editorRef]);
    return (React.createElement("div", { className: "editor" },
        React.createElement(react_ace_1.default, { ref: editorRef, width: "100%", height: "100%", mode: "javascript", commands: commands, showPrintMargin: false, editorProps: { $blockScrolling: true }, wrapEnabled: true, style: {
                background: "transparent",
                color: "white",
            }, className: "editor__code", defaultValue: props.startValue, enableBasicAutocompletion: false, enableLiveAutocompletion: false, enableSnippets: false, setOptions: {
                fontFamily: "Fixedsys Excelsior, monospace",
                fontSize: 18,
                useWorker: true,
                showLineNumbers: true,
                showGutter: false,
                highlightActiveLine: true,
            } }),
        props.error && (React.createElement("div", { className: "editor__error" },
            React.createElement("div", { className: "editor__error__line" }, props.error),
            React.createElement("div", { className: "editor__error__close", onClick: props.closeError }, "x")))));
}
